<nz-spin [nzSpinning]="loading">  


    <div class="register-container">  
      <nz-card>  
        <form nz-form [formGroup]="validateForm" (ngSubmit)="submitForm()" class="register-form">  
            <div class="move-right-container">
          <nz-form-item>  
            <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>{{ "VendorMobile" | translate }}</nz-form-label>  
            <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Please input your phone number!">  
              <input formControlName="phoneNumber" nz-input  class="full-width-other" />  
            </nz-form-control>  
          </nz-form-item>  
    
          <nz-form-item>  
            <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzTooltipTitle="{{'VendorLimit'|translate}}">{{ "VendorCode" | translate }}</nz-form-label>  
            <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="The input is not a valid VendorCode !">  
              <input nz-input formControlName="vendorCode" placeholder="{{'VendorLimit'|translate}}"  class="full-width-other" />  
            </nz-form-control>  
          </nz-form-item>  
    
          <nz-form-item>  
            <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzTooltipTitle="{{ 'SupplierContact' | translate }}">{{ "SupplierContact" | translate }}</nz-form-label>  
            <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Please input the supplier contact!">  
              <input nz-input formControlName="vendorContact"  class="full-width-other" />  
            </nz-form-control>  
          </nz-form-item>  
    
          <nz-form-item>  
            <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>{{ "VendorMail" | translate }}</nz-form-label>  
            <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="The input is not a valid E-mail!">  
              <input nz-input formControlName="email"  class="full-width-other" placeholder="{{'EmailLimit'|translate}}" />  
            </nz-form-control>  
          </nz-form-item>  

          <nz-form-item>  
            <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>{{"Site"|translate}}</nz-form-label>  
            <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Please input the Site !">  
              <nz-select formControlName="Site"  class="full-width" (ngModelChange)="getCompanyCodeList($event)">  
                <nz-option *ngFor="let option of SiteList" [nzLabel]="option.siteName" [nzValue]="option"></nz-option>  
              </nz-select>  
            </nz-form-control>  
          </nz-form-item>  

          <nz-form-item>  
            <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>{{ "CompanyCode" | translate }}</nz-form-label>  
            <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Please input the company code!">  
              <nz-select formControlName="companyCode" nzMode="multiple" class="full-width">  
                <nz-option *ngFor="let option of CompanyCodeList" [nzLabel]="option.legalcode" [nzValue]="option.legalcode"></nz-option>  
              </nz-select>  

            </nz-form-control>  
          </nz-form-item>  
    

    
          <nz-form-item>  
            <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>{{ "VendorGroup" | translate }}</nz-form-label>  
            <nz-form-control [nzSm]="18" [nzXs]="24" nzErrorTip="Please input the vendorGroup!">  
              <nz-select formControlName="vendorGroup" nzMode="multiple" class="full-width" >  
                <nz-option *ngFor="let option of VendorGroupList" [nzLabel]="option.typeName" [nzValue]="option.type"></nz-option>  
              </nz-select>  
            </nz-form-control>  
          </nz-form-item>
    
          
          <nz-form-item > 
            <nz-form-control [nzSm]="24" [nzXs]="24" style="display: flex; justify-content: flex-end;">  
              <button nz-button nzSize="large" nzType="primary" class="custom-submit-button" style="margin-left: 25%;"> <!-- 调整 margin-right 以确保按钮不会超出容器 -->  
                {{ "Submit" | translate }}  
              </button>  
            </nz-form-control>  
          </nz-form-item>

        
          
            </div>
        </form>  
      </nz-card>  
    </div>  
  </nz-spin>